import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"pa-2"},[_c('iframe',{staticStyle:{"border":"0","width":"100%","height":"500px","padding-bottom":"0","z-index":"5"},attrs:{"srcdoc":_vm.rawHTMLFor3DSecure}})])}
var staticRenderFns = []

export { render, staticRenderFns }